import React from 'react';
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import {IAppDoctorTimesResult} from "../../store/rtk-api/appointment_times/types";

type Props = {
    doctor: IAppDoctorTimesResult
}

const DoctorsList: React.FC<Props> = ({doctor}) => {
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c9c7c7",
            // borderRight: "2px solid #c9c7c7",
            height: "60px",
            maxWidth: "400px",
            paddingLeft: "10px",
            gap: "10px",
            boxSizing: "border-box"
        }}>
            {
                <>
                    <img src={doctor.photo} alt="" style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50px"
                    }}/>
                    <Typography sx={{
                        color: "primary.dark",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}>
                        {`${doctor?.last_name} ${doctor?.first_name} ${doctor?.middle_name}`}
                    </Typography>

                </>
            }
        </Box>
    );
};

export default DoctorsList;